export const DEFAULT_ITEMS_COUNT_PER_ROW = 4;
